export default __webpack_public_path__ + "static/media/8.5x11FCTLogoInfo.4e5ff34f.svg";